import EventBus from '../../utils/EventBus';
import setTemporaryFocus from '../../utils/setTemporaryFocus';
import EventDataObject from '../EventDataObject';

export default {
    props: {
        config: {},
        initial: '',
        focusPrefix: '',
    },
    data: function () {
        return {
            selected: this.initial || '',
            selectedTitle: ''
        }
    },
    watch: {
        selectedTitle: function(newVal, oldVal) {
            EventBus.$emit('ContentSelector:onSelect', { oldVal, newVal }, this.config.eventData);
        }
    },
    mounted() {
        // Emit an event we're ready, but wait for all child components
        this.$nextTick(function () {
            this.$emit('ready', this);
            Array.from(this.$el.querySelectorAll('[data-eventdata]')).forEach(function (element) {
                new EventDataObject(element);
            });
        });

    },
    updated() {
        // Updated is called after DOM changes are patched in the browser, so
        // we can do DOM dependent operations (like height comparisons).
        // With $nextTick we know that all child components are re-rendered too.
        // @see https://vuejs.org/v2/api/#updated
        this.$nextTick(function () {
            this.$emit('updated', this);
        });
    },
    methods: {
        isSelected (item) {
            return (this.selected === item);
        },
        handleSelectChange(event) {
            let select = event.currentTarget;
            this.selectedTitle = select.options[select.selectedIndex].innerHTML;
        },
        updateSelected(item, title) {
            // Set the selected item
            this.selected = item;

            // Update the selected title
            this.selectedTitle = title;

            // Should we change the focus?
            if (this.focusPrefix) {
                let focusItem = this.$refs[this.focusPrefix + this.selected];

                if (typeof focusItem !== 'undefined') {
                    this.$nextTick(function () {
                        setTemporaryFocus(focusItem);
                    });
                }
            }
        }
    }
}
